var _defs;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgHobby(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    x: "0px",
    y: "0px",
    viewBox: "0 0 2500 2500",
    style: {
      enableBackground: "new 0 0 2500 2500"
    },
    xmlSpace: "preserve",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, /*#__PURE__*/React.createElement("g", {
    id: "Illustration"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Winter_hiking_1_"
  }, /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#F2E6DC"
    },
    d: "M2154.657,1250.98c0,505.882-405.742,907.151-911.014,907.151S335.38,1756.861,335.38,1250.98 S744.984,335,1250.257,335c484.219,0,880.576,376.635,912.766,853.265C2164.422,1208.989,2154.657,1229.901,2154.657,1250.98z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#FFFFFF"
    },
    d: "M2162.039,1177.298l-144.932,254.919l-96.999,70.63l-145.498,123.602l-66.136,150.088 l-295.406-17.657l-246.906,92.702l-185.18-8.829l-255.406,174.12C870.161,2112.686,1063.564,2165,1249.934,2165 c505.272,0,914.876-410.098,914.876-915.98C2164.81,1224.883,2163.871,1200.965,2162.039,1177.298z"
  }), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#FFFFFF"
    },
    d: "M1368.203,911.33l-205.801-188.701l-115.932,96.838l-72.111-51.859l-28.693,37.522l-16.554-4.414 l-58.49,82.769l-65.112-46.351L677.493,946.389L537.644,808.021l-77.558,162.648c-3.368,7.701-14.516-7.074-17.658,0 c-54.041,121.71-76.148,176.574-102.993,256.936c-0.278,0.833-0.552,34.426-0.552,35.315c0,17.989,2.288,84.349,3.311,102.082 l1126.599-202.447L1368.203,911.33z"
  }), /*#__PURE__*/React.createElement("polygon", {
    style: {
      fill: "#F7F1EB"
    },
    points: "1359.328,1307.699 1125.344,919.503 1036.677,1045.582 987.807,983.057 908.026,1092.882  868.157,1045.582 754.135,1175.777 652.45,1034.204 534.731,1183.854 488.327,1141.446 349.764,1312.028  "
  }), /*#__PURE__*/React.createElement("polygon", {
    style: {
      fill: "#F2E6DC"
    },
    points: "371.623,1295.291 569.534,1216.569 724.036,1269.541 854.26,1205.533 1132.365,1313.685  "
  }), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#F7F1EB"
    },
    d: "M1026.275,1041.523l42.928,17.005l137.779-217.114l90.269,30.315l129.054-197.348 l145.512,193.402l105.704-51.795l133.137,210.8l57.002,23.91l42.548-45.952l210.42,170.439 c14.411,51.829,28.778,103.565,31.821,132.247l-1249.917,2.115l-1.667-27.87l84.917-128.807L1026.275,1041.523z"
  }), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("polygon", {
    style: {
      fill: "#F2E6DC"
    },
    points: "1434.797,698.868 1435.286,783.592 1465.862,844.868 1477.092,904.161 1502.29,949.108  1509.027,1011.023 1615.861,1111.181 1554.433,1015.508 1535.861,939.827 1500.772,900.038 1496.293,824.068 1462.233,799.101  "
  }), /*#__PURE__*/React.createElement("polygon", {
    style: {
      fill: "#F2E6DC"
    },
    points: "1074.233,1157.757 1091.64,1072.933 1138.729,1033.57 1165.781,939.721  1216.35,884.932 1165.781,985.673 1150.774,1052.468 1113.944,1076.25  "
  }), /*#__PURE__*/React.createElement("polygon", {
    style: {
      fill: "#F2E6DC"
    },
    points: "1887.186,1105.856 1821.764,1069.801 1741.844,1041.17 1708.139,992.572  1680.747,922.934 1658.603,828.093 1714.261,958.455 1771.019,1033.04 1840.86,1056.016  "
  }), /*#__PURE__*/React.createElement("polygon", {
    style: {
      fill: "#F2E6DC"
    },
    points: "1300.297,884.932 1338.154,920.63 1359.583,971.085 1408.209,1036.679  1417.746,1095.555 1473.953,1132.284 1538.57,1228.116 1457.677,1228.116 1450.058,1167.19 1381.487,1096.395  1371.963,1028.203 1334.821,974.893 1320.297,923.843  "
  }), /*#__PURE__*/React.createElement("polygon", {
    style: {
      fill: "#F2E6DC"
    },
    points: "1965.408,1128.368 1949.816,1085.339 1917.282,1034.788 1933.071,1101.432  1961.978,1151.385 2049.515,1188.279  "
  }), /*#__PURE__*/React.createElement("polygon", {
    style: {
      fill: "#F2E6DC"
    },
    points: "1027.866,1065.383 1033.877,1115.4 1031.402,1152.516 997.777,1191.86  956.783,1218.472 1010.059,1155.389  "
  }))), /*#__PURE__*/React.createElement("polygon", {
    style: {
      fill: "#FFFFFF"
    },
    points: "2152.817,1304.488 1710.591,1096.429 1619.494,1155.22 1579.4,1142.655  1315.924,1266.077 1221.012,1179.306 1126.866,1254.73 1009.141,1206.809 799.336,1310.353 2154.657,1320.674  "
  }), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("polygon", {
    style: {
      fill: "#E6D0BE"
    },
    points: "997.531,1310.374 714.137,1316.085 777.13,1153.889 841.902,1064.393 916.192,1146.678  "
  }), /*#__PURE__*/React.createElement("polygon", {
    style: {
      fill: "#E6D0BE"
    },
    points: "961.214,1202.641 737.928,1202.641 836.203,1010.323  "
  }), /*#__PURE__*/React.createElement("polygon", {
    style: {
      fill: "#E6D0BE"
    },
    points: "903.015,1000.82 786.834,1000.82 839.463,912.443  "
  }), /*#__PURE__*/React.createElement("polygon", {
    style: {
      fill: "#E6D0BE"
    },
    points: "938.886,1134.122 751.884,1134.122 844.77,989.384  "
  }), /*#__PURE__*/React.createElement("polygon", {
    style: {
      fill: "#E6D0BE"
    },
    points: "923.628,1070.942 768.723,1070.942 841.438,951.788  "
  }))), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#363E44"
    },
    d: "M1567.175,1266.985c0,0,39.005,167.448,33.642,224.265 c-5.229,55.395-72.759,207.01-72.759,207.01h-92.58l39.171-220.475l-50.102-201.05L1567.175,1266.985z"
  }), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#D87355"
    },
    d: "M1412.467,1785.739l20.228-87.362l10.852-57.943l110.486,2.925l-17.78,54.9 c48.236-0.055,72.941,39.004,72.996,87.24L1412.467,1785.739z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#363E44"
    },
    d: "M1534.877,1717.868c-0.565,0-1.127-0.215-1.558-0.644c-0.864-0.862-0.864-2.259-0.004-3.121 l16.826-16.864c0.862-0.866,2.259-0.862,3.121-0.004c0.864,0.862,0.864,2.259,0.004,3.121l-16.825,16.864 C1536.009,1717.652,1535.442,1717.868,1534.877,1717.868z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#363E44"
    },
    d: "M1554.033,1723.59c-0.565,0-1.127-0.216-1.558-0.644c-0.864-0.862-0.864-2.259-0.004-3.121 l16.826-16.864c0.862-0.866,2.259-0.862,3.121-0.004c0.864,0.862,0.864,2.259,0.004,3.121l-16.825,16.864 C1555.164,1723.375,1554.598,1723.59,1554.033,1723.59z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#363E44"
    },
    d: "M1537.537,1696.026c-0.024,0-0.045,0-0.069,0l-23.809-0.711 c-1.218-0.037-2.175-1.054-2.141-2.274c0.039-1.216,1.078-2.136,2.274-2.14l23.809,0.711c1.218,0.037,2.175,1.054,2.14,2.274 C1539.705,1695.08,1538.725,1696.026,1537.537,1696.026z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#363E44"
    },
    d: "M1544.303,1678.149c-0.024,0-0.045,0-0.069,0l-23.809-0.711 c-1.218-0.036-2.175-1.054-2.141-2.274c0.039-1.218,1.084-2.099,2.274-2.14l23.809,0.711c1.218,0.037,2.175,1.054,2.14,2.274 C1546.471,1677.203,1545.491,1678.149,1544.303,1678.149z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#363E44"
    },
    d: "M1551.037,1660.192c-0.024,0-0.045,0-0.069,0l-23.809-0.714 c-1.218-0.037-2.175-1.054-2.14-2.274c0.037-1.22,1.067-2.089,2.274-2.14l23.809,0.713c1.218,0.037,2.175,1.054,2.14,2.274 C1553.205,1659.248,1552.224,1660.192,1551.037,1660.192z"
  }))), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#363E44"
    },
    d: "M1465.271,1305.666c0,0-65.127,159.118-102.391,202.342 c-36.331,42.142-179.163,126.679-179.163,126.679l-75.49-53.593l159.57-157.102l75.531-192.941L1465.271,1305.666z"
  }), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#D87355"
    },
    d: "M1211.195,1761.184l-172.373-122.079l67.066-59.526l42.391-40.965l88.398,66.344 l-46.279,34.474C1229.763,1667.31,1239.074,1721.821,1211.195,1761.184z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#363E44"
    },
    d: "M1179.203,1655.032c-1.056,0-1.99-0.759-2.174-1.836c-0.205-1.201,0.602-2.341,1.804-2.546 l23.48-4.011c1.21-0.2,2.343,0.601,2.548,1.804c0.205,1.201-0.603,2.341-1.804,2.546l-23.48,4.011 C1179.451,1655.021,1179.326,1655.032,1179.203,1655.032z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#363E44"
    },
    d: "M1191.51,1670.786c-1.056,0-1.99-0.759-2.174-1.836c-0.205-1.201,0.602-2.341,1.804-2.546 l23.48-4.011c1.211-0.192,2.343,0.604,2.548,1.804s-0.602,2.341-1.804,2.546l-23.48,4.011 C1191.758,1670.775,1191.633,1670.786,1191.51,1670.786z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#363E44"
    },
    d: "M1194.012,1638.76c-0.463,0-0.93-0.144-1.329-0.446l-19.002-14.364 c-0.972-0.735-1.165-2.119-0.43-3.091c0.735-0.976,2.118-1.168,3.092-0.431l19.002,14.364c0.972,0.735,1.165,2.119,0.43,3.091 C1195.341,1638.459,1194.681,1638.76,1194.012,1638.76z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#363E44"
    },
    d: "M1209.879,1628.1c-0.463,0-0.93-0.144-1.329-0.446l-19.003-14.364 c-0.972-0.735-1.165-2.119-0.43-3.091c0.735-0.976,2.118-1.168,3.092-0.431l19.002,14.364c0.972,0.735,1.165,2.119,0.43,3.091 C1211.207,1627.798,1210.547,1628.1,1209.879,1628.1z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#363E44"
    },
    d: "M1225.764,1617.355c-0.464,0-0.93-0.144-1.329-0.446l-19.002-14.364 c-0.972-0.735-1.165-2.119-0.43-3.091c0.736-0.976,2.117-1.168,3.092-0.431l19.002,14.364c0.972,0.735,1.165,2.119,0.43,3.091 C1227.093,1617.053,1226.432,1617.355,1225.764,1617.355z"
  })))), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#776E42"
    },
    d: "M1278.583,1228.908c-21.272,1.616-54.393-29.067-64.744-40.281 c-13.243-14.347-26.486-28.693,106.661-276.057c16.891-31.382,49.569-51.031,85.199-50.242l106.11,18.582L1278.583,1228.908z"
  }), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#D87355"
    },
    d: "M1855.552,1126.19c-5.047-1.895-9.179-2.244-11.52-2.453 c-22.349-1.996-72.118-5.41-92.737-6.602c-0.002,0-8.178,91.473-8.178,91.473c38.33-0.149,51.586-2.815,90.295,4.13 c0.003,0.001,0.006,0.003,0.009,0.004c1.805,2.024,22.216,5.943,39.724,4.578c14.986-1.168,28.771-8.107,25.38-16.784 c-0.117-0.3,0.197-0.638,0.414-0.879c4.615-5.13,6.402-10.637,4.692-15.851c-0.178-0.545-0.75-1.216-0.393-1.649 c2.551-3.094,6.185-9.309,1.778-13.767c-0.344-0.347-0.1-1.002,0.066-1.451c4.639-12.581-1.28-20.598-5.73-22.824 C1884.397,1128.231,1873.689,1132.995,1855.552,1126.19z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#363E44"
    },
    d: "M1767.329,1828.188l-14.885-2.608l0.379-2.175l123.921-706.712l14.886,2.608l-0.379,2.175 L1767.329,1828.188z M1757.552,1821.993l6.19,1.086l122.779-700.191l-6.191-1.086L1757.552,1821.993z"
  }), /*#__PURE__*/React.createElement("polygon", {
    style: {
      fill: "#363E44"
    },
    points: "1855.576,1219.528 1875.992,1223.942 1898.064,1113.031 1872.681,1108.617  "
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#D87355"
    },
    d: "M1891.442,1152.393c-7.344-0.701-15.268,4.639-15.249,7.925c0.017,2.868,3.884,6.314,9.468,7.06 c-6.368-0.584-11.158,3.55-11.386,7.163c-0.243,3.854,4.59,8.941,11.583,8.405c-8.121-1.198-14.13,2.973-14.46,6.396 c-0.327,3.381,4.646,8.52,12.64,9.077c-8.77-1.034-14.904,3.17-15.133,6.636c-0.202,3.066,4.114,7.034,10.526,8.549 L1891.442,1152.393z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#D87355"
    },
    d: "M1864.405,1154.232c25.917,0.332,44.324-4.264,44.245-8.373 c-0.132-6.91-22.141-16.251-59.957-21.508C1854.809,1133.51,1858.289,1145.074,1864.405,1154.232z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#363E44"
    },
    d: "M1902.478,1169.314h-26.486c-1.22,0-2.207-0.987-2.207-2.207s0.987-2.207,2.207-2.207h26.486 c1.22,0,2.207,0.987,2.207,2.207S1903.698,1169.314,1902.478,1169.314z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#363E44"
    },
    d: "M1900.457,1185.868c-0.045,0-0.091-0.002-0.136-0.004l-24.462-1.472 c-1.216-0.073-2.143-1.119-2.069-2.337c0.073-1.216,1.147-2.11,2.337-2.069l24.462,1.472c1.216,0.073,2.142,1.119,2.069,2.336 C1902.586,1184.965,1901.614,1185.868,1900.457,1185.868z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#363E44"
    },
    d: "M1896.411,1202.605c-0.088,0-0.177-0.004-0.267-0.015l-22.807-2.759 c-1.209-0.146-2.074-1.248-1.927-2.457c0.147-1.211,1.235-2.063,2.457-1.927l22.807,2.759c1.209,0.146,2.074,1.248,1.927,2.457 C1898.465,1201.784,1897.512,1202.605,1896.411,1202.605z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#363E44"
    },
    d: "M1866.795,1157.543c-1.125,0-2.087-0.856-2.194-1.998c-0.116-1.214,0.774-2.291,1.987-2.406 c9.316-0.884,34.06-3.231,37.175-5.479c0.985-0.716,2.365-0.493,3.08,0.498c0.714,0.987,0.491,2.367-0.498,3.08 c-2.979,2.151-13.64,3.858-39.339,6.294C1866.935,1157.541,1866.864,1157.543,1866.795,1157.543z"
  })), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#EFBC73"
    },
    d: "M1810.666,1114.437c0,0-306.236-75.254-306.895,34.545 c-0.609,101.483,279.389,87.159,279.389,87.159L1810.666,1114.437z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#EFBC73"
    },
    d: "M1523.975,869.247c-13.668-0.825-27.05,1.459-40.115,6.354 c-93.935,11.945-376.345,55.601-342.176,145.335c13.121,34.457,101.333,39.346,190.005,35.036 c-73.98,148.405-81.433,330.75-81.433,330.75l360.874,39.729C1611.131,1426.451,1682.049,878.789,1523.975,869.247z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#EFBC73"
    },
    d: "M1474.472,988.131c0,0,123.755,276.447,213.473,213.147 c82.922-58.505-102.873-286.43-102.873-286.43L1474.472,988.131z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#FFFFFF"
    },
    d: "M1626.583,1231.115c-1.218,0-2.207-0.987-2.209-2.205c-0.019-14.834,0.121-29.745,0.271-45.532 c0.726-76.704,1.479-156.02-16.819-215.575c-0.358-1.166,0.297-2.401,1.461-2.759c1.166-0.362,2.403,0.297,2.759,1.461 c18.498,60.208,17.744,139.874,17.013,216.916c-0.151,15.774-0.291,30.672-0.272,45.484 C1628.79,1230.124,1627.803,1231.113,1626.583,1231.115z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#FFFFFF"
    },
    d: "M1508.167,1126.386c-0.121,0-0.244-0.009-0.366-0.03l-120.237-20.128 c-0.578-0.097-1.093-0.418-1.433-0.895c-0.339-0.479-0.476-1.069-0.38-1.647l16.944-101.211 c0.097-0.578,0.418-1.093,0.894-1.433c0.476-0.336,1.069-0.468,1.647-0.379l120.237,20.13c1.203,0.2,2.013,1.339,1.813,2.541 l-16.944,101.209C1510.161,1125.623,1509.225,1126.386,1508.167,1126.386z M1390.469,1102.239l115.883,19.399l16.215-96.855 l-115.883-19.401L1390.469,1102.239z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#FFFFFF"
    },
    d: "M1697.129,1094.906c-0.086,0-0.175-0.004-0.265-0.015c-13.138-1.573-25.878-2.789-37.871-3.615 c-1.218-0.084-2.134-1.138-2.052-2.354c0.086-1.218,1.153-2.112,2.354-2.052c12.068,0.832,24.885,2.056,38.095,3.636 c1.209,0.144,2.073,1.244,1.929,2.455C1699.183,1094.083,1698.23,1094.906,1697.129,1094.906z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#FFFFFF"
    },
    d: "M1583.174,1200.355c-0.075,0-0.153-0.004-0.231-0.011c-1.211-0.127-2.093-1.211-1.966-2.425 c15.136-145.54-27.432-287.99-27.864-289.41c-0.19-0.627-0.093-1.306,0.267-1.854l22.037-33.569 c0.67-1.022,2.043-1.3,3.056-0.634c1.02,0.668,1.302,2.037,0.634,3.056l-21.477,32.715 c3.792,13.032,42.294,150.168,27.734,290.152C1585.25,1199.51,1584.291,1200.355,1583.174,1200.355z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#776E42"
    },
    d: "M1349.212,1042.033c22.583-61.314,38.509-116.133,35.315-152.295l52.236-11.771 c-61.655,173.147-110.359,313.42-162.228,335.491l1.104-38.074L1349.212,1042.033z"
  }), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#D87355"
    },
    d: "M1322.537,1040.984c31.962,28.189,110.519,90.847,117.944,97.268 c13.879,12.005,87.056,69.194,73.079,82.134c-6.59,6.101-39.196-22.21-46.505-28.484c6.992,8.501,17.915,19.266,8.777,26.505 c-9.404,7.45-25.337-11.069-25.801-11.243c3.663,4.555,18.952,21.006,9.598,29.643c-9.007,8.318-21.078-13.748-26.27-17.359 c3.913,6.373,22.952,28.04,17.071,33.455c-7.88,7.255-31.365-21.795-36.369-24.501c-12.34-10.656-34.29-24.121-59.563-41.827 c-59.356-41.585-84.078-62.62-109.114-87.9C1235.675,1088.87,1292.388,1039.878,1322.537,1040.984z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#EFBC73"
    },
    d: "M1430.941,1110.919c0,0-228.922-213.677-287.554-120.841 c-54.191,85.805,208.341,229.955,208.341,229.955L1430.941,1110.919z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#FFFFFF"
    },
    d: "M1351.727,1222.241c-0.36,0-0.724-0.088-1.06-0.272c-0.321-0.177-32.649-17.983-71.723-44.335 c-1.009-0.681-1.276-2.054-0.595-3.065c0.681-1.009,2.052-1.274,3.065-0.595c33.817,22.809,62.545,39.177,69.679,43.178 l76.908-105.94c-12.325-11.284-101.396-91.538-178.372-126.204c-1.111-0.502-1.607-1.808-1.106-2.921 c0.499-1.11,1.805-1.599,2.918-1.106c83.149,37.449,180.036,127.419,181.006,128.322c0.815,0.761,0.933,2.009,0.28,2.912 l-79.213,109.115C1353.087,1221.92,1352.414,1222.241,1351.727,1222.241z"
  }))), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("rect", {
    x: 1509.607,
    y: 793.007,
    transform: "matrix(0.9928 0.1197 -0.1197 0.9928 112.6813 -178.2582)",
    style: {
      fill: "#E2A18D"
    },
    width: 61.257,
    height: 111.739
  }), /*#__PURE__*/React.createElement("polygon", {
    style: {
      fill: "#EFBC73"
    },
    points: "1577.813,860.087 1496.783,850.446 1479.073,921.076 1580.007,909.26  "
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#E2A18D"
    },
    d: "M1585.089,864.038c-15.248,8.281-51.658-23.583-51.658-23.583l-16.976-50.219 c2.922-24.235,24.936-41.512,49.171-38.59c24.235,2.922,41.512,24.936,38.59,49.171 C1604.217,800.817,1600.62,855.603,1585.089,864.038z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#E2A18D"
    },
    d: "M1597.783,811.747c0,0,10.753,14.379,9.688,17.705c-1.271,3.969-15.28,4.795-15.28,4.795 S1598.106,811.818,1597.783,811.747z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#FFFFFF"
    },
    d: "M1558.409,805.095c0,0,7.823-3.065,16.678-1.997c1.884,0.227-3.488,14.876-5.174,13.807 C1562.502,812.202,1558.409,805.095,1558.409,805.095z"
  }), /*#__PURE__*/React.createElement("g", null, _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("path", {
    id: "SVGID_1_",
    d: "M1558.409,805.095c0,0,11.505-4.509,22.406-0.685c10.9,3.824,17.067,14.532,17.067,14.532 s-11.505,4.509-22.406,0.685C1564.576,815.803,1558.409,805.095,1558.409,805.095z"
  }))), /*#__PURE__*/React.createElement("clipPath", {
    id: "SVGID_00000046332061005552443670000003281192972464827569_"
  }, /*#__PURE__*/React.createElement("use", {
    xlinkHref: "#SVGID_1_",
    style: {
      overflow: "visible"
    }
  })), /*#__PURE__*/React.createElement("circle", {
    style: {
      clipPath: "url(#SVGID_00000046332061005552443670000003281192972464827569_)",
      fill: "#363E44"
    },
    cx: 1584.835,
    cy: 814.639,
    r: 15.107
  })), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#363E44"
    },
    d: "M1581.161,842.785c-1.936,0-3.85-0.662-5.384-1.944c-2.436-2.035-3.524-5.352-2.772-8.449 c0.287-1.188,1.481-1.918,2.664-1.625c1.186,0.287,1.912,1.481,1.625,2.664c-0.358,1.479,0.157,3.056,1.313,4.022 c1.203,1.002,2.897,1.203,4.313,0.515c1.099-0.526,2.416-0.073,2.949,1.022c0.532,1.097,0.075,2.418-1.022,2.949 C1583.675,842.507,1582.413,842.785,1581.161,842.785z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#363E44"
    },
    d: "M1571.319,867.073c-0.214,0-0.429-0.03-0.645-0.097c-17.071-5.208-37.91-23.335-38.787-24.102 c-0.918-0.804-1.011-2.199-0.209-3.115c0.806-0.922,2.198-1.011,3.115-0.209c0.209,0.183,21.009,18.274,37.171,23.206 c1.166,0.356,1.821,1.589,1.466,2.755C1573.141,866.461,1572.266,867.073,1571.319,867.073z"
  }), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#D87355"
    },
    d: "M1599.5,766.594c-3.999-8.432-11.016-19.406-23.401-28.237 c-38.527-27.469-92.107-7.896-96.51-6.216c-0.135,3.993,0.075,15.044,8.255,24.852c3.929,4.71,8.407,7.59,11.679,9.29 c-1.151,6.194-2.888,12.503-2.585,18.168c0.556,10.371,2.027,19.354,4.456,25.626c12.491-7.541,30.53-18.978,48.132-26.452 C1567.873,775.834,1584.855,770.418,1599.5,766.594z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#EFBC73"
    },
    d: "M1511.915,827.166c10.255-9.544,22.995-22.544,46.89-29.981 c19.651-6.116,32.922-9.429,45.221-9.523c3.234-5.786,1.196-18.051-3.716-24.415c-13.707,1.696-30.455,4.927-48.904,11.15 c-23.39,7.889-39.718,19.418-53.728,33.388C1499.224,818.77,1506.903,824.303,1511.915,827.166z"
  }), /*#__PURE__*/React.createElement("ellipse", {
    transform: "matrix(0.4672 -0.8842 0.8842 0.4672 128.0757 1683.2166)",
    style: {
      fill: "#EFBC73"
    },
    cx: 1460.626,
    cy: 735.342,
    rx: 24.391,
    ry: 24.391
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#FFFFFF"
    },
    d: "M1497.566,769.308c-1.063,0-1.998-0.767-2.175-1.849c-0.198-1.203,0.616-2.339,1.819-2.535 c3.371-0.556,6.706-1.412,9.913-2.543c5.333-1.882,10.376-4.539,14.991-7.904c0.985-0.716,2.367-0.5,3.085,0.485 c0.718,0.985,0.5,2.365-0.485,3.084c-4.96,3.615-10.385,6.475-16.121,8.499c-3.451,1.216-7.04,2.136-10.667,2.733 C1497.806,769.3,1497.685,769.308,1497.566,769.308z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#FFFFFF"
    },
    d: "M1444.098,734.375c-0.054,0-0.106-0.002-0.159-0.006l-13.187-0.946 c-1.216-0.086-2.132-1.142-2.043-2.358c0.086-1.216,1.155-2.151,2.358-2.043l13.187,0.946c1.216,0.086,2.132,1.142,2.043,2.358 C1446.215,733.487,1445.245,734.375,1444.098,734.375z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#FFFFFF"
    },
    d: "M1435.194,748.661c-0.843,0-1.647-0.483-2.015-1.302c-0.5-1.11-0.004-2.418,1.108-2.918 l12.053-5.427c1.11-0.498,2.418-0.006,2.919,1.108c0.5,1.11,0.004,2.418-1.108,2.919l-12.053,5.427 C1435.804,748.599,1435.496,748.661,1435.194,748.661z"
  })))), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#D87355"
    },
    d: "M508.065,1165.138c0,0-150.265,113.477-148.68,222.838 c1.585,109.361,105.003,134.079,105.003,134.079l71.323-148.193L508.065,1165.138z"
  }), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#EFBC73"
    },
    d: "M730.553,1372.301l-1.559,33.181c0,0,216.233,108.252,234.759,173.631 c18.526,65.379-62.386,248.692-62.386,248.692l-117.908,14.013l16.947-195.543l-155.017-65.973 c0,0-83.82,237.148-119.239,349.481l-119.801-1.907c0,0,35.85-397.762,66.16-497.203c8.17-26.803,31.695-81.872,31.695-81.872 L730.553,1372.301z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#363E44"
    },
    d: "M858.384,1517.531l-99.691-60.221l15.369-23.438c0.671-1.015,2.04-1.304,3.056-0.634 c1.02,0.668,1.304,2.037,0.636,3.056l-12.858,19.606l92.416,55.824l14.786-18.968c0.751-0.961,2.138-1.127,3.097-0.384 c0.961,0.75,1.134,2.138,0.384,3.1L858.384,1517.531z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#363E44"
    },
    d: "M484.235,1668.338l-49.529-6.117c-1.21-0.149-2.069-1.25-1.921-2.462 c0.151-1.207,1.257-2.076,2.461-1.918l45.35,5.6l20.062-116.935l-49.499-7.072c-1.206-0.172-2.044-1.291-1.872-2.498 c0.171-1.209,1.288-2.054,2.497-1.873l53.993,7.714L484.235,1668.338z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#363E44"
    },
    d: "M495.455,1592.114c-0.106,0-0.212-0.006-0.319-0.024l-50.528-7.316 c-1.207-0.175-2.043-1.293-1.869-2.5c0.176-1.205,1.305-2.061,2.5-1.867l50.528,7.316c1.207,0.175,2.043,1.293,1.869,2.5 C497.477,1591.323,496.534,1592.114,495.455,1592.114z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#363E44"
    },
    d: "M645.391,1582.51c-0.193,0-0.389-0.026-0.585-0.078c-1.175-0.323-1.867-1.537-1.544-2.714 l11.808-43.055c0.322-1.177,1.531-1.856,2.713-1.546c1.175,0.323,1.867,1.537,1.544,2.714l-11.807,43.055 C647.25,1581.867,646.361,1582.51,645.391,1582.51z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#363E44"
    },
    d: "M800.409,1648.481c-0.742,0-1.465-0.373-1.882-1.05c-0.639-1.039-0.316-2.399,0.722-3.037 l38.028-23.41c1.038-0.642,2.397-0.317,3.037,0.722c0.639,1.039,0.316,2.399-0.722,3.037l-38.028,23.41 C801.203,1648.376,800.803,1648.481,800.409,1648.481z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#363E44"
    },
    d: "M799.516,1481.6c-0.357,0-0.718-0.086-1.053-0.269c-1.07-0.582-1.467-1.923-0.884-2.992 l12.854-23.622c0.584-1.076,1.922-1.472,2.994-0.884c1.07,0.582,1.467,1.923,0.884,2.992l-12.854,23.622 C801.056,1481.184,800.298,1481.6,799.516,1481.6z"
  })), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#363E44"
    },
    d: "M783.46,1841.818l-8.027,141.456l237.742-23.18c0,0-43.982-69.539-114.116-71.917l27.34-84.528 l-6.214,0.709c-17.703,2.019-33.644,11.659-43.655,26.398L783.46,1841.818z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#FFFFFF"
    },
    d: "M910.269,1856.506h-27.258c-1.219,0-2.207-0.987-2.207-2.207c0-1.22,0.988-2.207,2.207-2.207 h27.258c1.219,0,2.207,0.987,2.207,2.207C912.476,1855.519,911.488,1856.506,910.269,1856.506z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#FFFFFF"
    },
    d: "M904.796,1874.75h-27.258c-1.219,0-2.207-0.987-2.207-2.207c0-1.22,0.988-2.207,2.207-2.207 h27.258c1.219,0,2.207,0.987,2.207,2.207C907.003,1873.763,906.015,1874.75,904.796,1874.75z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#FFFFFF"
    },
    d: "M876.341,1900.632c-0.821,0-1.61-0.461-1.99-1.25c-0.529-1.099-0.067-2.416,1.031-2.947 l24.561-11.82c1.098-0.524,2.418-0.065,2.945,1.032c0.529,1.099,0.067,2.416-1.031,2.947l-24.561,11.82 C876.989,1900.563,876.662,1900.632,876.341,1900.632z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#FFFFFF"
    },
    d: "M900.313,1911.61c-0.589,0-1.178-0.235-1.612-0.701c-0.832-0.89-0.786-2.287,0.104-3.119 l19.912-18.617c0.889-0.834,2.286-0.789,3.12,0.106c0.832,0.89,0.786,2.287-0.104,3.119l-19.912,18.617 C901.395,1911.414,900.854,1911.61,900.313,1911.61z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#FFFFFF"
    },
    d: "M951.42,1856.508c-0.087,0-0.174-0.002-0.261-0.002l-40.923-0.614 c-0.934-0.015-1.76-0.617-2.058-1.502c-0.299-0.886-0.006-1.865,0.73-2.442l32.208-25.253 c4.317-3.386,9.808-4.434,15.072-2.856c5.259,1.571,9.28,5.455,11.033,10.659c1.752,5.201,0.902,10.725-2.332,15.159 C961.703,1854.021,956.805,1856.508,951.42,1856.508z M916.541,1851.572l34.683,0.519c0.064,0.002,0.128,0.002,0.192,0.002 c3.962,0,7.562-1.83,9.904-5.039c2.379-3.261,3.004-7.324,1.715-11.148c-1.289-3.826-4.246-6.684-8.113-7.839 c-3.87-1.16-7.907-0.39-11.083,2.102L916.541,1851.572z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#FFFFFF"
    },
    d: "M940.661,1889.562c-4.67,0-8.917-2.153-11.683-5.934l-20.491-28.027 c-0.552-0.754-0.569-1.776-0.041-2.548c0.527-0.774,1.481-1.132,2.389-0.888l33.554,8.908c4.605,1.222,8.2,4.485,9.861,8.952 c1.662,4.468,1.072,9.288-1.618,13.224c-2.689,3.934-6.963,6.236-11.729,6.311 C940.824,1889.562,940.742,1889.562,940.661,1889.562z M915.734,1858.034l16.807,22.988c1.956,2.673,4.93,4.123,8.293,4.125 c3.313-0.054,6.284-1.653,8.154-4.391c1.87-2.735,2.281-6.087,1.125-9.193c-1.154-3.106-3.654-5.374-6.857-6.223 L915.734,1858.034z"
  })), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#363E44"
    },
    d: "M406.862,1912.037l-27.148,139.059l238.688,9.296c0,0-34.139-74.865-103.301-86.737 l38.558-80.036l-6.252-0.141c-17.813-0.402-34.915,6.986-46.834,20.23L406.862,1912.037z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#FFFFFF"
    },
    d: "M528.865,1941.657h-27.258c-1.219,0-2.207-0.987-2.207-2.207s0.988-2.207,2.207-2.207h27.258 c1.219,0,2.207,0.987,2.207,2.207S530.084,1941.657,528.865,1941.657z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#FFFFFF"
    },
    d: "M523.393,1959.901h-27.258c-1.219,0-2.207-0.987-2.207-2.207s0.988-2.207,2.207-2.207h27.258 c1.219,0,2.207,0.987,2.207,2.207S524.612,1959.901,523.393,1959.901z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#FFFFFF"
    },
    d: "M494.938,1985.781c-0.821,0-1.61-0.461-1.989-1.25c-0.529-1.099-0.067-2.416,1.031-2.947 l24.561-11.821c1.098-0.522,2.418-0.065,2.945,1.033c0.529,1.099,0.067,2.416-1.031,2.946l-24.561,11.82 C495.585,1985.712,495.259,1985.781,494.938,1985.781z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#FFFFFF"
    },
    d: "M517.086,2000.408c-0.59,0-1.178-0.235-1.612-0.701c-0.832-0.89-0.786-2.287,0.104-3.119 l19.911-18.617c0.889-0.836,2.286-0.789,3.12,0.106c0.832,0.89,0.786,2.287-0.104,3.119l-19.911,18.617 C518.168,2000.212,517.627,2000.408,517.086,2000.408z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#FFFFFF"
    },
    d: "M570.017,1941.657c-0.087,0-0.173-0.002-0.261-0.002l-40.924-0.614 c-0.934-0.015-1.76-0.616-2.058-1.502c-0.299-0.886-0.006-1.864,0.73-2.442l32.208-25.253c4.32-3.384,9.814-4.417,15.072-2.856 c5.259,1.573,9.28,5.458,11.034,10.659c1.752,5.201,0.901,10.728-2.333,15.159 C580.299,1939.17,575.403,1941.657,570.017,1941.657z M535.138,1936.721l34.685,0.519c0.063,0.002,0.128,0.002,0.192,0.002 c3.961,0,7.561-1.83,9.903-5.04c2.378-3.259,3.005-7.324,1.716-11.148c-1.289-3.826-4.246-6.682-8.114-7.837 c-3.866-1.157-7.907-0.392-11.083,2.099L535.138,1936.721z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#FFFFFF"
    },
    d: "M559.257,1974.711c-4.67,0-8.916-2.153-11.681-5.936l-20.492-28.023 c-0.552-0.754-0.569-1.774-0.041-2.548c0.528-0.77,1.484-1.134,2.388-0.888l33.555,8.906c4.607,1.224,8.201,4.488,9.862,8.956 c1.661,4.466,1.071,9.286-1.618,13.219c-2.689,3.934-6.964,6.236-11.73,6.311 C559.42,1974.711,559.338,1974.711,559.257,1974.711z M534.331,1943.183l16.808,22.988c1.957,2.675,5.023,4.19,8.292,4.125 c3.313-0.054,6.285-1.653,8.155-4.391c1.87-2.735,2.279-6.085,1.125-9.191c-1.155-3.106-3.655-5.376-6.858-6.225 L534.331,1943.183z"
  }))), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#776E42"
    },
    d: "M481.203,1180.354c-0.962-2.993-4.181-4.605-7.143-3.55 c-48.129,17.147-153.376,54.507-137.196,107.878c13.922,45.923,141.465,2.606,187.172-10.523 C515.739,1242.748,491.29,1211.723,481.203,1180.354z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#776E42"
    },
    d: "M819.305,1200.215c-27.248-14.683-125.649-51.415-197.493-51.415 c-62.115,0-143.058,26.638-170.922,36.332c-5.962,2.074-6.528,6.783-5.024,12.913c5.705,23.251,19.384,78.302,27.08,103.367 c15.552-0.566,5.067-1.131,20.619-1.696c-4.195,24.252-28.01,140.159-34.582,169.038 c98.123-0.283,176.303-62.254,274.426-62.537c-0.8-25.598,5.779-84.885,5.514-115.951 c11.201,2.545,53.339,14.451,64.932,16.996C811.207,1274.744,811.953,1232.734,819.305,1200.215z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#D87355"
    },
    d: "M703.413,1155.616l35.546,151.282c0,0,21.417-34.868-1.168-147.003L703.413,1155.616z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#776E42"
    },
    d: "M789.784,1186.972c93.316,38.74,142.876,81.057,125.327,115.18 c-10.18,19.794-72.426,21.018-147.675-5.649C775.007,1265.484,779.792,1224.298,789.784,1186.972z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#776E42"
    },
    d: "M725.777,1294.12c18.75,0,27.821-17.82,27.821-28.686c0-16.095-13.047-29.142-29.142-29.142 l-7.91-32.38L725.777,1294.12z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#363E44"
    },
    d: "M738.836,1292.994c-0.768,0-1.514-0.401-1.922-1.117c-0.601-1.06-0.231-2.408,0.829-3.009 c8.417-4.783,13.646-13.763,13.646-23.434c0-14.851-12.082-26.934-26.934-26.934h-1.733l-8.32-34.063 c-0.29-1.183,0.435-2.38,1.62-2.668c1.182-0.293,2.378,0.435,2.667,1.621l7.511,30.743 c16.477,0.91,29.604,14.601,29.604,31.301c0,11.256-6.085,21.708-15.879,27.271 C739.58,1292.901,739.206,1292.994,738.836,1292.994z"
  })), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#D87355"
    },
    d: "M508.065,1165.138l43.861-10.691c0,0,99.726,118.91,73.652,150.837 c-26.074,31.927-142.354,53.324-142.354,53.324l-0.214-42.622c0,0,111.948,0.25,114.221-20.169 C599.504,1275.398,508.065,1165.138,508.065,1165.138z"
  }), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#BC8271"
    },
    d: "M405.907,1230.085c39.248,8.618,132.679,24.339,141.738,26.236 c16.935,3.548,94.124,12.067,94.124,31.261c0,8.235-6.872,10.119-12.789,8.819c4.261,3.406,10.693,8.203,7.969,14.891 c-3.201,7.858-15.103,4.138-15.565,4.207c4.678,3.02,9.192,7.703,7.345,12.797c-2.404,6.627-8.732,8.065-14.927,6.231 c1.381,1.462,7.1,5.061,5.077,11.599c-1.414,4.572-8.954,5.608-16.892,4.611c-15.049-3.14-74.186-12.204-103.123-15.24 c-67.961-7.131-97.92-13.325-130.173-22.552c-12.625-3.612-24.667-12.096-29.766-22.135 c-6.454-12.708,4.701-22.001,17.424-28.426C375.488,1252.719,386.621,1239.88,405.907,1230.085z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#363E44"
    },
    d: "M629.318,1298.025c-0.398,0-0.801-0.108-1.163-0.332c-2.987-1.858-6.131-3.522-9.345-4.949 c-5.763-2.558-11.868-4.41-18.144-5.499c-1.202-0.209-2.006-1.351-1.798-2.552c0.208-1.2,1.355-1.998,2.552-1.798 c6.634,1.151,13.088,3.108,19.181,5.813c3.399,1.509,6.725,3.27,9.884,5.234c1.036,0.644,1.353,2.005,0.709,3.041 C630.776,1297.656,630.056,1298.025,629.318,1298.025z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#363E44"
    },
    d: "M621.811,1317.342c-0.321,0-0.648-0.069-0.956-0.218c-0.665-0.321-1.346-0.634-2.044-0.944 c-5.772-2.563-11.876-4.414-18.143-5.499c-1.202-0.207-2.007-1.349-1.799-2.552c0.207-1.201,1.355-1.996,2.551-1.798 c6.625,1.147,13.079,3.104,19.182,5.813c0.739,0.328,1.461,0.662,2.167,1c1.098,0.528,1.561,1.847,1.031,2.947 C623.421,1316.881,622.632,1317.342,621.811,1317.342z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#363E44"
    },
    d: "M613.43,1336.465c-0.238,0-0.482-0.039-0.72-0.121c-3.894-1.343-7.947-2.386-12.046-3.097 c-1.201-0.209-2.005-1.351-1.797-2.552c0.208-1.2,1.345-1.996,2.553-1.797c4.329,0.752,8.612,1.854,12.729,3.274 c1.152,0.397,1.764,1.653,1.367,2.806C615.202,1335.892,614.346,1336.465,613.43,1336.465z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#776E42"
    },
    d: "M563.824,1257.602l-22.072,84.976c-125.118-4.764-213.361-23.175-205.636-74.676l68.79-39.361 L563.824,1257.602z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#363E44"
    },
    d: "M564.193,1254.291c-0.133,0-0.267-0.011-0.402-0.037c-9.24-1.703-38.025-5.863-65.863-9.885 c-31.384-4.535-63.838-9.225-70.687-10.73c-1.191-0.261-1.944-1.438-1.682-2.63c0.262-1.188,1.448-1.929,2.629-1.681 c6.693,1.468,39.065,6.147,70.372,10.672c29.162,4.214,56.707,8.195,66.031,9.913c1.198,0.22,1.992,1.371,1.771,2.569 C566.166,1253.547,565.238,1254.291,564.193,1254.291z"
  })), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#BC8271"
    },
    d: "M860.309,1263.609c-0.001-0.002,4.528-33.523,4.531-33.524 c43.728-14.679,119.889-61.135,136.127-72.898c1.701-1.232,4.692-3.419,9.206-5.103c16.724-6.238,27.495,5.441,48.119,5.908 c5.98,0.135,27.691-6.103,32.148,0.763c2.264,3.488-0.49,9.145-4.823,11.448c-0.001,0.001,0,0.003,0,0.003 c3.635-1.198,9.38,0.982,9.982,4.639c1.775,5.06-0.758,9.552-4.986,10.529c1.823-0.421,6.711,0.921,7.751,5.825 c1.171,5.521-3.697,10.794-9.102,11.803c4.036-1.539,7.185,2.312,7.228,5.574c0.079,5.955-4.312,8.673-16.607,12.67 c-13.842,4.5-48.528,4.82-48.53,4.822c-57.891,45.932-78.531,64.23-127.301,85.15 C894.274,1315.411,876.052,1293.816,860.309,1263.609z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#BC8271"
    },
    d: "M1039.105,1161.051c17.668-14.976,20.868-24.122,18.405-26.847 c-4.141-4.582-24.459,2.03-53.039,20.665C1013.965,1157.456,1029.61,1158.463,1039.105,1161.051z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#363E44"
    },
    d: "M1025.659,1175.871c-0.721,0-1.428-0.354-1.852-1.002c-0.665-1.022-0.377-2.388,0.644-3.054 c4.446-2.897,8.638-6.212,12.462-9.855c2.028-1.931,3.978-3.979,5.794-6.083c0.795-0.925,2.189-1.026,3.113-0.229 c0.922,0.795,1.025,2.19,0.229,3.113c-1.909,2.211-3.958,4.365-6.09,6.395c-4.019,3.828-8.425,7.311-13.097,10.357 C1026.49,1175.755,1026.072,1175.871,1025.659,1175.871z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#776E42"
    },
    d: "M992.017,1159.382l38.626,75.044c-50.836,38.287-100.974,74.734-139.052,79.458 c-44.562-27.924-48.153-57.857-30.349-88.839L992.017,1159.382z"
  })), /*#__PURE__*/React.createElement("polygon", {
    style: {
      fill: "#363E44"
    },
    points: "1077.093,1226.314 1062.952,1226.958 1052.105,1139.926 1074.835,1138.102  "
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#363E44"
    },
    d: "M1107.267,1857.308l-0.157-2.201l-50.944-715.687l15.074-1.071l0.157,2.201l50.943,715.687 L1107.267,1857.308z M1060.882,1143.511l50.474,709.08l6.268-0.446l-50.473-709.08L1060.882,1143.511z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#BC8271"
    },
    d: "M1076.771,1157.319c-7.296,1.099-11.116,6.525-10.302,9.708 c0.711,2.779,5.297,5.185,10.896,4.557c-6.319,0.976-9.965,6.147-9.312,9.708c0.698,3.798,6.619,7.563,13.274,5.349 c-8.169,0.805-12.989,6.307-12.481,9.708c0.501,3.36,6.571,7.141,14.462,5.745c-8.759,1.121-13.692,6.685-13.075,10.104 c0.546,3.023,5.695,5.829,12.283,5.745L1076.771,1157.319z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#363E44"
    },
    d: "M1082.225,1220.153c-7.318,0-13.379-3.22-14.163-7.561c-0.323-1.791,0.269-3.83,1.672-5.742 c0.941-1.285,2.173-2.44,3.623-3.427c-1.172-0.448-2.256-1.022-3.215-1.714c-1.97-1.418-3.205-3.205-3.479-5.035 c-0.278-1.869,0.411-3.979,1.941-5.943c0.751-0.964,1.661-1.841,2.694-2.619c-0.268-0.134-0.532-0.276-0.792-0.429 c-2.511-1.485-4.197-3.668-4.624-5.992c-0.389-2.119,0.265-4.565,1.794-6.716c0.565-0.793,1.225-1.522,1.964-2.173 c-2.729-1.095-4.725-2.942-5.31-5.227c-0.479-1.873,0.011-4.042,1.377-6.102c2.209-3.332,6.121-5.641,10.734-6.337 c1.189-0.157,2.329,0.649,2.511,1.854c0.182,1.207-0.648,2.33-1.854,2.513c-3.331,0.5-6.214,2.149-7.712,4.408 c-0.765,1.155-0.899,2.106-0.78,2.569c0.335,1.311,3.555,3.47,8.512,2.91c1.191-0.123,2.276,0.711,2.433,1.903 c0.158,1.19-0.664,2.289-1.85,2.472c-2.677,0.414-5.02,1.787-6.427,3.768c-0.83,1.166-1.222,2.423-1.051,3.36 c0.191,1.035,1.16,2.179,2.528,2.987c1.436,0.849,3.122,1.222,4.857,1.207c1.128-0.308,2.302-0.526,3.501-0.645 c1.123-0.104,2.141,0.636,2.375,1.737c0.234,1.099-0.396,2.198-1.461,2.554c-1.224,0.407-2.471,0.651-3.709,0.737 c-2.615,0.787-4.833,2.181-6.229,3.972c-0.892,1.145-1.13,2.082-1.056,2.578c0.071,0.481,0.553,1.285,1.691,2.104 c2.311,1.664,5.721,2.367,9.267,1.933c0.344-0.058,0.691-0.11,1.04-0.155c1.2-0.132,2.283,0.675,2.463,1.858 c0.18,1.186-0.618,2.298-1.799,2.505c-0.351,0.063-0.704,0.116-1.055,0.16c-4.76,0.832-7.928,3.099-9.344,5.031 c-0.776,1.06-0.967,1.908-0.888,2.349c0.252,1.392,3.836,3.932,9.812,3.932c0.099,0,0.197,0.004,0.301-0.002 c1.205,0,2.191,0.97,2.206,2.179c0.015,1.218-0.96,2.22-2.179,2.235C1082.438,1220.153,1082.331,1220.153,1082.225,1220.153z"
  })), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("circle", {
    style: {
      fill: "#363E44"
    },
    cx: 584.592,
    cy: 1098.613,
    r: 20.471
  }), /*#__PURE__*/React.createElement("circle", {
    style: {
      fill: "#363E44"
    },
    cx: 584.592,
    cy: 1074.896,
    r: 20.471
  }), /*#__PURE__*/React.createElement("circle", {
    style: {
      fill: "#363E44"
    },
    cx: 580.571,
    cy: 1124.384,
    r: 20.471
  }), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#BC8271"
    },
    d: "M621.511,1173.406c13.756,0,24.907-11.151,24.907-24.907v-64.375 c0-13.756-11.151-24.907-24.907-24.907c-13.756,0-24.907,11.151-24.907,24.907v64.375 C596.603,1162.254,607.755,1173.406,621.511,1173.406z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#363E44"
    },
    d: "M684.219,1081.109c-0.918,2.72-1.692,10.965-0.696,20.637 c1.647,15.992,6.379,28.459,10.133,36.264c-4.903-6.437-13.169-19.041-16.932-37.064c-3.878-18.571-1.083-33.841,0.933-41.73 C680.946,1059.704,680.931,1080.62,684.219,1081.109z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#BC8271"
    },
    d: "M632.109,1019.258c2.172-0.211,22.999-1.915,35.544,12.326 c9.335,10.597,10.456,24.199,8.886,47.297c-1.848,27.201-6.753,43.203-14.583,48.572 c-12.371,8.483-49.444-10.489-63.385-34.239c-10.063-17.143-8.916-39.224,1.72-56.183 C610.898,1020.118,630.723,1019.392,632.109,1019.258z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#363E44"
    },
    d: "M647.393,1024.812c-1.975,5.806-4.616,12.058-8.177,18.487 c-14.005,25.29-29.617,44.122-42.613,51.437c-4.971-2.133-28.19-20.338-28.848-42.193 c-0.799-26.565,27.853-47.248,52.262-49.063c9.55-0.71,17.532,1.536,22.754,3.556c2.415-1.323,5.983-2.812,10.31-2.844 c16.444-0.124,24.578,19.599,28.996,32.833c6.908,20.693,4.003,40.604,1.224,46.804c-3.345-10.132-8.77-23.045-17.776-36.619 C659.452,1038.056,653.107,1030.646,647.393,1024.812z"
  }), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#BC8271"
    },
    d: "M617.365,1072.983c6.079,7.774,5.681,18.241-0.89,23.38 c-6.571,5.138-16.826,3.002-22.905-4.772c-6.079-7.774-5.681-18.241,0.89-23.38 C601.031,1063.073,611.286,1065.209,617.365,1072.983z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#363E44"
    },
    d: "M600.671,1090.567c-0.526,0-1.054-0.188-1.476-0.567c-0.54-0.487-1.049-1.035-1.512-1.625 c-3.832-4.901-3.461-11.622,0.831-14.978c1.086-0.851,2.335-1.423,3.714-1.703c1.192-0.244,2.359,0.528,2.603,1.722 c0.242,1.194-0.528,2.36-1.723,2.602c-0.701,0.144-1.331,0.431-1.873,0.856c-2.374,1.856-2.408,5.796-0.073,8.781 c0.306,0.39,0.638,0.75,0.989,1.065c0.905,0.817,0.979,2.211,0.163,3.117 C601.876,1090.322,601.275,1090.567,600.671,1090.567z"
  })), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#363E44"
    },
    d: "M628.728,1041.877c-4.645,10.663-10.189,26.614-12.266,46.663 c-2.067,19.953,0.059,36.632,2.4,47.996c-3.99-11.674-8.384-28.942-8.533-50.129c-0.116-16.495,2.377-30.422,5.067-40.797 C619.84,1044.365,624.284,1043.121,628.728,1041.877z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#363E44"
    },
    d: "M646.42,1130.734c-0.136,0-0.273-0.013-0.412-0.039c-10.662-2.011-21.076-6.861-28.569-13.306 c-0.925-0.793-1.029-2.188-0.235-3.112c0.795-0.923,2.189-1.032,3.112-0.233c6.924,5.953,16.587,10.441,26.511,12.314 c1.197,0.226,1.985,1.38,1.759,2.578C648.387,1129.995,647.461,1130.734,646.42,1130.734z"
  }), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#FFFFFF"
    },
    d: "M676.046,1078.385c-7.727,2.557-15.724-0.179-15.724-0.179s4.273-8.232,12.321-11.458 c0.169-0.068,0.339-0.133,0.509-0.195C681.056,1063.648,676.413,1078.263,676.046,1078.385z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#84524D"
    },
    d: "M673.156,1066.567c7.903-2.902,16.31-0.041,16.31-0.041s-4.273,8.232-12.321,11.457 c-0.367,0.147-0.735,0.267-1.104,0.389c-2.668-2.564-4.034-6.377-3.296-10.284 C672.845,1067.563,672.991,1067.06,673.156,1066.567z"
  })), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#FFFFFF"
    },
    d: "M620.562,1070.58c0,0,5.209,7.674,13.58,9.934c0.259,0.07,0.518,0.134,0.777,0.192 c8.104,1.823-1.551-12.593-3.406-12.565C625.461,1068.23,620.562,1070.58,620.562,1070.58z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#84524D"
    },
    d: "M650.875,1078.761c0,0-7.853,3.767-15.957,1.944c-1.622-1.346-2.893-3.153-3.572-5.314 c-0.774-2.466-0.652-4.993,0.166-7.249c1.856-0.028,3.819,0.154,5.784,0.684 C645.667,1071.087,650.875,1078.761,650.875,1078.761z"
  })), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#363E44"
    },
    d: "M661.267,1096.527c-0.643,0-1.283-0.28-1.718-0.821c-0.766-0.948-0.619-2.337,0.33-3.104 c1.14-0.92,1.807-1.813,1.787-2.386c-0.011-0.313-0.293-0.664-0.985-1.448c-0.663-0.752-1.489-1.688-2.232-3.05 c-1.09-1.996-1.647-4.266-1.659-6.746c-0.005-1.22,0.978-2.212,2.198-2.218c0.003,0,0.007,0,0.01,0 c1.215,0,2.202,0.981,2.207,2.196c0.008,1.742,0.385,3.309,1.12,4.656c0.505,0.925,1.096,1.595,1.667,2.244 c0.947,1.073,2.02,2.289,2.086,4.212c0.074,2.069-1.079,4.08-3.425,5.977C662.245,1096.368,661.754,1096.527,661.267,1096.527 z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#363E44"
    },
    d: "M655.804,1106.578c-2.191,0-4.419-0.776-6.201-2.229c-1.508-1.224-2.591-2.88-3.049-4.656 c-0.305-1.181,0.405-2.384,1.585-2.69c1.182-0.3,2.386,0.405,2.689,1.586c0.224,0.871,0.779,1.701,1.561,2.334 c1.326,1.082,3.209,1.498,4.685,1.061c1.165-0.349,2.399,0.31,2.75,1.474c0.351,1.168-0.309,2.399-1.477,2.75 C657.525,1106.457,656.667,1106.578,655.804,1106.578z"
  }))), /*#__PURE__*/React.createElement("ellipse", {
    transform: "matrix(0.1602 -0.9871 0.9871 0.1602 -648.7659 1533.6685)",
    style: {
      fill: "#363E44"
    },
    cx: 576.923,
    cy: 1148.101,
    rx: 17.43,
    ry: 17.43
  }), /*#__PURE__*/React.createElement("ellipse", {
    transform: "matrix(0.2298 -0.9732 0.9732 0.2298 -693.9508 1459.493)",
    style: {
      fill: "#363E44"
    },
    cx: 575.098,
    cy: 1168.169,
    rx: 17.43,
    ry: 17.43
  }), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#EFBC73"
    },
    d: "M635.682,1174.681c2.222,18.277,6.13,39.436,12.95,62.44 c4.807,16.212,10.295,30.761,15.855,43.559c-5.505,3.827-14.501,9.079-26.654,12.12c-10.057,2.516-18.789,2.645-24.901,2.252 c-3.471-14.235-6.475-30.871-7.951-49.543c-2.328-29.446-0.153-55.064,3.115-75.183 C617.291,1171.777,626.487,1173.229,635.682,1174.681z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#EFBC73"
    },
    d: "M622.131,1182.393c-2.585,21.949-4.019,47.736-2.578,76.5c1.015,20.271,3.296,38.796,6.157,55.3 c-7.505,2.905-19.486,6.483-34.523,6.588c-12.443,0.087-22.665-2.236-29.684-4.426c-0.017-17.588,1.191-37.843,4.757-60.041 c5.625-35.007,15.417-64.272,24.927-86.815C601.501,1173.798,611.817,1178.096,622.131,1182.393z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#FFD092"
    },
    d: "M622.806,1297.29c-1.092,0-2.04-0.811-2.186-1.923c-1.565-12.019-2.666-24.253-3.272-36.365 c-1.28-25.542-0.408-51.403,2.59-76.868c0.143-1.209,1.246-2.095,2.45-1.933c1.211,0.142,2.077,1.239,1.935,2.451 c-2.969,25.219-3.832,50.834-2.566,76.13c0.601,11.995,1.692,24.111,3.242,36.015c0.157,1.209-0.695,2.315-1.904,2.472 C622.998,1297.283,622.901,1297.29,622.806,1297.29z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#EFBC73"
    },
    d: "M591.519,1132.539c5.255,8.488,14.281,13.001,29.027,14.398 c19.431,1.841,31.617,0.093,39.465-2.221c7.951,9.741,4.552,25.382,0.8,32.199c-10.464,19.012-68.433,18.801-82.087-6.771 C570.709,1155.136,583.997,1137.696,591.519,1132.539z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#FFD092"
    },
    d: "M625,1192.557c-13.54,0-28.635-3.197-39.255-11.187c-0.974-0.733-1.171-2.117-0.438-3.091 c0.732-0.972,2.115-1.17,3.091-0.435c11.256,8.467,31.402,12.286,48.985,9.301c1.212-0.218,2.342,0.604,2.547,1.804 c0.205,1.203-0.604,2.343-1.805,2.546C634.093,1192.182,629.637,1192.557,625,1192.557z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#FFD092"
    },
    d: "M625.256,1168.271c-0.082,0-0.164-0.004-0.247-0.013c-7.579-0.843-18.901-3.505-29.808-11.391 c-5.493-3.973-10.284-8.831-14.241-14.442c-0.703-0.996-0.465-2.373,0.532-3.076c0.993-0.698,2.372-0.463,3.076,0.532 c3.675,5.212,8.123,9.721,13.219,13.407c10.129,7.326,20.659,9.799,27.708,10.581c1.213,0.136,2.084,1.226,1.95,2.438 C627.321,1167.437,626.365,1168.271,625.256,1168.271z"
  })), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#8B865C"
    },
    d: "M672.26,1010.286c-16.291-29.369-79.24-43.271-87.274-43.149 c-5.54,8.074-29.834,48.58-21.944,87.59c12.367-10.441,30.013-23.089,53.185-33.5 C632.714,1013.82,659.583,1013.05,672.26,1010.286z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#EFBC73"
    },
    d: "M568.2,1079.351c6.053-9.755,17.574-25.267,37.171-37.635 c34.467-21.751,60.616-18.126,71.911-16.688c2.241-7.297-0.985-24.235-15.923-28.822c-14.43,0.285-37.105-0.508-65.749,15.816 c-23.778,13.55-29.853,23.768-37.46,35.592C552.894,1058.363,559.475,1074.883,568.2,1079.351z"
  }), /*#__PURE__*/React.createElement("ellipse", {
    transform: "matrix(0.9308 -0.3656 0.3656 0.9308 -311.1461 278.735)",
    style: {
      fill: "#EFBC73"
    },
    cx: 580.546,
    cy: 961.081,
    rx: 19.169,
    ry: 19.169
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#363E44"
    },
    d: "M574.774,958.66c-0.619,0-1.233-0.259-1.669-0.761l-9.494-10.958 c-0.799-0.922-0.698-2.317,0.223-3.115c0.922-0.802,2.316-0.696,3.114,0.222l9.494,10.958c0.799,0.922,0.698,2.317-0.223,3.115 C575.802,958.483,575.286,958.66,574.774,958.66z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#363E44"
    },
    d: "M567.452,961.568c-0.215,0-0.433-0.03-0.65-0.097l-8.824-2.712 c-1.165-0.358-1.819-1.593-1.461-2.759c0.359-1.166,1.591-1.819,2.759-1.461l8.824,2.711c1.165,0.358,1.819,1.593,1.461,2.759 C569.269,960.958,568.395,961.568,567.452,961.568z"
  })), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#363E44"
    },
    d: "M581.397,1176.915c1.111,7.26,3.653,17.677,9.932,28.704 c11.469,20.144,28.396,30.006,36.068,33.86c-2.416,1.25-12.273,2.304-24.175-1.514c-14.504-4.653-23.144-20.278-23.338-21.101 c0.382,6.294,1.896,12.511,3.703,17.745c2.883,8.349,8.488,16.358,11.014,19.685c-10.457-4.645-21.981-10.729-28.652-26.483 c-10.48-24.75-0.177-47.506,1.615-51.296C572.174,1176.65,576.785,1176.782,581.397,1176.915z"
  }))))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgHobby);
export default __webpack_public_path__ + "static/media/hobby.4c4b980c15d622a0ec41f7fef9ebcc24.svg";
export { ForwardRef as ReactComponent };